<div class="d-flex flex-column">
    <div 
    [attr.id]="folder.id"
    (drop)="droppedOnFolder($event)"
    (dragover)="$event.preventDefault();addFileHover = true"
    (dragleave)="addFileHover = false"
    class="folder d-flex align-items-center cursor-pointer gap-3" 
    [ngClass]="{'active': selected == folder.id, 'fileHov': !!addFileHover }">
        <div class="folderSwitch" [ngStyle]="{ 'margin-left': (level * 2.5) + 'rem' }" (click)="folder.open = !folder.open">
            <span *ngIf="!!folder.open && !!folder.children.length">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
            </span>
            <span *ngIf="!folder.open && !!folder.children.length">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                </svg>
            </span>
            <span *ngIf="!folder.children.length"></span>
        </div>
        <div class="d-flex justify-content-between align-items-center gap-3 w-100" (click)="selectedChange.emit(folder.id)">
            <div class="d-flex align-items-center gap-3">
                <div class="folderIcon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="hero-icon">
                        <path d="M19.5 21a3 3 0 003-3v-4.5a3 3 0 00-3-3h-15a3 3 0 00-3 3V18a3 3 0 003 3h15zM1.5 10.146V6a3 3 0 013-3h5.379a2.25 2.25 0 011.59.659l2.122 2.121c.14.141.331.22.53.22H19.5a3 3 0 013 3v1.146A4.483 4.483 0 0019.5 9h-15a4.483 4.483 0 00-3 1.146z" />
                    </svg>
                </div>
                <div *ngIf="!rename" (click)="folderClick($event)">{{ folder?.name }}</div>
                <div *ngIf="folder.parentId && rename"><input type="text" class="form-control" [(ngModel)]="folder.name" (blur)="rename = false" (change)="renameFolder({id:folder.id, name: folder.name})"></div>
            </div>
            <div class="minibadge bg-primary text-white" *ngIf="folder.count">{{ folder.count }}</div>
        </div>
    </div>
    <div class="folderHolder" [ngStyle]="{'display': folder.open == true && !!folder.children.length ? 'block' : 'none'}">
        <case-file-folder [folder]="childFolder" [selected]="selected" (selectedChange)="isChildOpen($event);selectedChange.emit($event)" (drop)="drop.emit($event)" (rename)="emitFolderRename($event)" *ngFor="let childFolder of folder.children" [level]="level + 1"></case-file-folder>
    </div>
</div>
